var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer, Observer } from 'mobx-react';
import { QuestionAnswerState } from '../../../classes/learnware/LearnwareEnums';
import { AvailableTooltip } from '../../../components/other/AvailableTooltip';
import { runtime } from '../../../classes/runtime/Runtime';
let CycleBarCountdownTime = class CycleBarCountdownTime extends React.PureComponent {
    get empty() {
        return (React.createElement("div", { style: {
                width: 45,
                height: 45,
            } }));
    }
    render() {
        const { app } = this.props;
        if (!app.question)
            return null;
        if (app.question.answeringState.currentAnswerState !== QuestionAnswerState.Feedback)
            return this.empty;
        if (app.question.answeringFeedback.isFeedbackTimeNearlyOver) {
            return this.empty;
        }
        const x = runtime.streamedPackages.Lazy;
        return (React.createElement(AvailableTooltip, { title: "Sekunden bis zur n\u00E4chsten Frage", placement: "top" },
            React.createElement("div", { onClick: () => (app.appClock.isAppClockPaused = true), style: {
                    width: 45,
                    height: 45,
                    fontSize: 22,
                    background: 'rgba(0,0,0,0.03)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                } },
                React.createElement(Observer, null, () => React.createElement(React.Fragment, null, app.question.answeringFeedback.remainingFeedbackTimeInSeconds)))));
    }
};
CycleBarCountdownTime = __decorate([
    observer
], CycleBarCountdownTime);
export { CycleBarCountdownTime };
